import { FiActivity, FiAlertOctagon, FiDatabase, FiInbox, FiRefreshCw, FiSettings } from 'react-icons/fi';
import { useNavigate, useParams } from 'react-router-dom';

import Tab, { TabProps } from '../../../molecules/Tab';
import { Topology } from '../../../../services/eventingApi';

export const TAB_SLUGS = ['visao-geral', 'eventos', 'outbox', 'filas', 'backfill', 'configuracao'] as const;

export type TabSlug = (typeof TAB_SLUGS)[number];

export const useTabNavigation = () => {
  const { tab } = useParams();
  const navigate = useNavigate();
  const index = Math.max(0, TAB_SLUGS.indexOf((tab ?? 'visao-geral') as TabSlug));
  return { active: TAB_SLUGS[index], index, goTo: (slug: TabSlug) => navigate(`/ti/event-platform/${slug}`) };
};

const totals = (topology: Topology | null) => ({
  pending: (topology?.outbox ?? []).reduce((sum, row) => sum + row.pending, 0),
  deadLetters: (topology?.subscriptions ?? []).reduce((sum, row) => sum + (row.deadLetterMessages ?? 0), 0),
});

interface EventPlatformTabsProps {
  topology: Topology | null;
  index: number;
  onSelect: (slug: TabSlug) => void;
}

const EventPlatformTabs = ({ topology, index, onSelect }: EventPlatformTabsProps) => {
  const { pending, deadLetters } = totals(topology);
  const items: TabProps[] = [
    { id: 'event-platform-overview', title: 'Visão geral', icon: FiActivity, index: 0 },
    { id: 'event-platform-events', title: 'Eventos', icon: FiInbox, index: 1 },
    { id: 'event-platform-outbox', title: 'Outbox', icon: FiDatabase, index: 2, badge: pending || undefined },
    { id: 'event-platform-queues', title: 'Filas e DLQs', icon: FiAlertOctagon, index: 3, badge: deadLetters || undefined },
    { id: 'event-platform-backfill', title: 'Backfill', icon: FiRefreshCw, index: 4 },
    { id: 'event-platform-config', title: 'Configuração', icon: FiSettings, index: 5 },
  ];

  return <Tab tabItems={items} tabIndex={index} setTabIndex={(next) => onSelect(TAB_SLUGS[next])} compact />;
};

export default EventPlatformTabs;
